<div class="row {{ bgClass }}" (click)="remove()">
  <div class="col-12 position-relative">
    @if (title()) {
      <div [class]="options().titleClass" [attr.aria-label]="title()" class="custom-title text-center">
        {{ title() }}
      </div>
    }
    @if (message() && options().enableHtml) {
      <div role="alert" aria-live="polite" class="custom-message text-center"
        [class]="options().messageClass" [innerHTML]="message()">
      </div>
    }
    @if (message() && !options().enableHtml) {
      <div role="alert" aria-live="polite" class="custom-message text-center"
        [class]="options().messageClass" [attr.aria-label]="message()">
        {{ message() }}
      </div>
    }

    @if (showCloseButton) {
      <span class="toast-close-button" aria-label="Close" (click)="closeToast($event)">x
      </span>
    }
  </div>
</div>
@if (options().progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width() + '%'"></div>
  </div>
}
